import React, {useContext,useEffect} from 'react';
import {useNavigate } from "react-router-dom";
import Transitioner from "../outlet-components/Transitioner";
import OutletWrapper from "../outlet-components/OutletWrapper";
function Steps(props) {
    const navigate = useNavigate()
    const onReturn = ()=>{
        navigate(props.back)
    }
    const onFinish = (bool)=>{
        navigate('../end')
    }
    useEffect(() => {
        props.transition.on()
        return () => {
            props.transition.off()
        }
    }, [])
    return (
        <OutletWrapper
            title={props.section.title}
            back={'../..'}
        >
        <Transitioner
            section={props.section}
            onFinish={onFinish}
            onReturn={onReturn}
            transition={props.transition}
            //lastSlideProps={{...props.lastSlideProps, random:limit, repeater: props?.repeater}}
           />
        </OutletWrapper>
    );
}

export default Steps;